import { c as _c } from "react/compiler-runtime";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { selectBenchmarkResults } from "#/features/callstack/model/callstackSlice";
import { useAppSelector } from "#/store/hooks";
import { BenchmarkChart } from "./BenchmarkChart";
const StatChip: React.FC<{
  label: string;
  value: number | undefined;
}> = t0 => {
  const $ = _c(12);
  const {
    label,
    value
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] !== theme.palette.action.hover) {
    t1 = {
      display: "inline-flex",
      alignItems: "baseline",
      gap: 0.5,
      px: 1.25,
      py: 0.5,
      borderRadius: 1,
      backgroundColor: theme.palette.action.hover
    };
    $[0] = theme.palette.action.hover;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label) {
    t2 = <Typography variant="caption" color="text.secondary">{label}</Typography>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== value) {
    t3 = value != null ? `${value.toFixed(2)} ms` : "\u2014";
    $[4] = value;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <Typography variant="caption" fontWeight={600}>{t3}</Typography>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t4) {
    t5 = <Box sx={t1}>{t2}{t4}</Box>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export const BenchmarkView = () => {
  const $ = _c(23);
  const benchmarkResults = useAppSelector(selectBenchmarkResults);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      xs: 1,
      md: 2
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = benchmarkResults?.averageTime;
  let t2;
  if ($[1] !== t1) {
    t2 = <StatChip label="Avg" value={t1} />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = benchmarkResults?.medianTime;
  let t4;
  if ($[3] !== t3) {
    t4 = <StatChip label="Med" value={t3} />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = benchmarkResults?.p75Time;
  let t6;
  if ($[5] !== t5) {
    t6 = <StatChip label="P75" value={t5} />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = benchmarkResults?.p90Time;
  let t8;
  if ($[7] !== t7) {
    t8 = <StatChip label="P90" value={t7} />;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = benchmarkResults?.p95Time;
  let t10;
  if ($[9] !== t9) {
    t10 = <StatChip label="P95" value={t9} />;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const t11 = benchmarkResults?.p99Time;
  let t12;
  if ($[11] !== t11) {
    t12 = <StatChip label="P99" value={t11} />;
    $[11] = t11;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== t10 || $[14] !== t12 || $[15] !== t2 || $[16] !== t4 || $[17] !== t6 || $[18] !== t8) {
    t13 = <Stack direction="row" flexWrap="wrap" gap={1} useFlexGap={true}>{t2}{t4}{t6}{t8}{t10}{t12}</Stack>;
    $[13] = t10;
    $[14] = t12;
    $[15] = t2;
    $[16] = t4;
    $[17] = t6;
    $[18] = t8;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <BenchmarkChart />;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t13) {
    t15 = <Stack spacing={t0}>{t13}{t14}</Stack>;
    $[21] = t13;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  return t15;
};